import type { CooperationForm, ZusStatus } from "../api/types";

export const FORMY: { value: CooperationForm; label: string }[] = [
  { value: "zlecenie", label: "Umowa zlecenia" },
  { value: "dzielo", label: "Umowa o dzieło" },
  { value: "b2b", label: "B2B (faktura)" },
];

/**
 * Status ubezpieczeniowy pytamy wyłącznie przy zleceniu — przy dziele i B2B
 * nie ma czego rozgałęziać. To jest to samo drzewo decyzyjne co w kreatorze
 * danych wykonawcy (CLAUDE.md §4.3), tylko widziane od strony kosztorysu.
 */
export const STATUSY: { value: ZusStatus; label: string; hint?: string }[] = [
  { value: "brak", label: "Brak innych tytułów", hint: "Pełne oskładkowanie." },
  { value: "student", label: "Student poniżej 26 lat", hint: "Wymaga oświadczenia i legitymacji." },
  { value: "inny_pracodawca", label: "Zatrudniony gdzie indziej", hint: "Wymaga oświadczenia o kwocie." },
  { value: "emeryt", label: "Emeryt lub rencista", hint: "Wymaga oświadczenia." },
  { value: "dzialalnosc", label: "Prowadzi własną działalność", hint: "Wymaga oświadczenia." },
];

export const NAZWY_SKLADEK: Record<string, string> = {
  emerytalna: "Emerytalna",
  rentowa: "Rentowa",
  wypadkowa: "Wypadkowa",
  fp_fs: "Fundusz Pracy / FS",
  fgsp: "FGŚP",
};

export function wymagaStatusu(forma: CooperationForm): boolean {
  return forma === "zlecenie";
}
